var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('i',{staticClass:"fa",class:'fa-' + _vm.icon}):_vm._e(),_vm._t("default",[_vm._v(" "+_vm._s(_vm.label)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }